<template>
  <div id="pdf" style="top: 0px;left: 0px;right: 0px;bottom: 0px;background-color: white;font-size: 14px;font-family: sans-serif;overflow:scroll;">
    <div class="paper" style="width: 720px;margin: auto;">
      <table id="p-table" class="table w-full text-left whitespace-no-wrap">
        <thead v-if="type && type!='PaymentsByseller'" class="bg-gray-200">
          <tr class="text-left" v-if="type && type=='payments'">
            <th class="border p-2">Pyament ID</th>
            <th class="border p-2">Warehouse</th>
            <th  v-if="currentUser.type!='Seller'"  class="border p-1 text-center ">Seller</th>
            <th class="border p-2 text-center">Payement methode</th>
            <th class="border p-2 text-center">NB Orders</th>
            <th class="border p-2 text-center">Payement date</th>
            <th class="border p-2 text-center">Periode</th>
            <th class="border p-2 text-center">Amount</th>
            <th class="border p-2 text-center">Status</th>
          </tr>
          <tr class="text-left" v-else-if="type && type=='expeditions'">
            <th class="border p-2">Expedition ID</th>
            <th class="border p-2">Warehouse</th>
            <th  v-if="currentUser.type!='Seller'"  class="border p-1 text-center ">Seller</th>
            <th class="border p-2 text-center"> Weight (Kg)</th>
            <th class="border p-2 text-center"> Transport Mode </th>
            <th class="border p-2 text-center"> Details </th>
            <th class="border p-2 text-center">CARRIER</th>
            <th class="border p-2 text-center">Country</th>
             <th class="border p-2 text-center"> Expedition Date </th>
              <th class="border p-2 text-center"> Reception Date </th>
            <th class="border p-2 text-center">Status</th>
          </tr>
          <tr class="text-left" v-else>
            <th class="border p-2">Seller</th>
            <th class="border p-2 text-center">Number of Orders</th>
            <th class="border p-2 text-center">Amount total to pay</th>
          </tr>
        </thead>
         <thead v-else class="responsive-table">
              <tr>
                <th style="background-color: #4299e1;border: 1px solid #4e504a;" :rowspan="items.length>0?3:''">Seller</th>
                <th style="background-color: #4299e1;border: 1px solid #4e504a;" :colspan="items.length>0?items[0][1].length*2+1:''">Warehouses</th>
                <th style="background-color: #4299e1;border: 1px solid #4e504a;" :rowspan="items.length>0?3:''">Payment method</th>
                <th style="background-color: #4299e1;border: 1px solid #4e504a;" :rowspan="items.length>0?3:''">RIB</th>
            </tr>
            <tr v-if="items.length>0" class="warehouses">
              <th v-for="(item, index) in items[0][1]" :key="'header-'+index" :colspan="item.name=='Total pending'?3:2" style="background-color: #6a6a6d;color:#fff;border: 1px solid #4e504a;">{{item.name}} <sup v-if="item.currency">({{item.currency}})</sup></th>
            </tr>
            <tr v-if="items.length>0" class="orders">
              <template v-for="(item1) in items[0][1]">
                <th style="background-color: #cacaca;border: 1px solid #4e504a;">Orders</th>
                <th style="background-color: #cacaca;border: 1px solid #4e504a;">Amount</th>
                <th v-if="item1.name=='Total pending'" style="background-color: #cacaca;border: 1px solid #4e504a;">Mad</th>
              </template>
            </tr>
         </thead>
        <tbody v-if="type && type=='payments'">
          <tr v-if="items.length == 0" >
            <th class="border p-3 bg-gray-100" colspan="8">
              No order found
            </th>
          </tr>
          <tr class="text-center" v-for="(item, index) in items" :key="index" :class="index % 2 == 0 ? 'bg-gray-100' : ''">
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.id }}
              </span>
            </td>
            <td  class="border p-2">
              <span class="flex items-center">
                {{ idWharhouse.name }}
              </span>
            </td>
            <td  v-if="currentUser.type!='Seller'"  class="border p-2">
              <span class="flex items-center">
                {{ item.seller && item.seller.fullName ? item.seller.fullName.replace(/[^a-zA-Z 0-9]+/g,'') : "" }}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.method}}
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{ item.count }}
              </span>
            </td>
            <td class="border p-2  bg-green-100">
              {{  $moment(item.date).format('DD-MM-YYYY') }}
            </td>
             <td class="border p-2  bg-green-100">
              {{ item.intervalDate && item.intervalDate.toDate && item.intervalDate.fromDate ? '[ '+$moment(item.intervalDate.fromDate).format('yyyy-MM-DD')+' - '+$moment(item.intervalDate.toDate).format('yyyy-MM-DD')+']' : "" }}
            </td>
             <td class="border p-2  bg-green-100">
              {{ item.amount }}
            </td>
            
            <td class="border p-2  bg-green-100">
              {{ item.status }}
            </td>
            
          </tr>
        </tbody>
         <tbody v-else-if="type && type=='expeditions'">
          <tr v-if="items.length == 0" >
            <th class="border p-3 bg-gray-100" colspan="10">
              No expeditions found
            </th>
          </tr>
          <tr class="text-center" v-for="(item, index) in items" :key="index">
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.id }}
              </span>
            </td>
            <td  class="border p-2">
              <span class="flex items-center">
                {{ idWharhouse.name }}
              </span>
            </td>
            <td  v-if="currentUser.type!='Seller'"  class="border p-2">
              <span class="flex items-center">
                 {{ item.seller && item.seller.fullName ? item.seller.fullName.replace(/[^a-zA-Z 0-9]+/g,'') : "" }}
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{ item.weight }}
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{ item.transportMode }}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.details.length+' Products' }} 
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{ item.carrier?item.carrier.name:'' }}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.country }}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{  $moment(item.date).format('DD-MM-YYYY') }}
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{  item.arrivalDate?$moment(item.arrivalDate).format('DD-MM-YYYY'):''}}
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{ item.status }}
              </span>
            </td>
          </tr>
         </tbody>
         <tbody v-else-if="type && type=='PaymentsByseller'">
                <tr v-if="items.length == 0" class="intro-x empty-tab">
                  <td colspan="3" class="text-center-imp padding-empty">No Data Found </td>
                </tr>
                <tr v-for="(ele, index) in items" :key="'seller-'+index" class="intro-x">
                  <td scope="row" style="border: 1px solid black;border-collapse: collapse;vertical-align: middle;display: table-cell;">
                      {{ele[2].userData }}
                  </td>
                  <template v-for="(item2) in ele[1]" >
                      <td style="border: 1px solid black;border-collapse: collapse;vertical-align: middle;display: table-cell;" :style="item2.count?randomHexColor(item2.index):'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">{{item2.count}}</td>
                      <td style="border: 1px solid black;border-collapse: collapse;vertical-align: middle;display: table-cell;" :style="item2.count?randomHexColor(item2.index):'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">
                         <span v-if="item2.sumSameCurrency && item2.sumSameCurrency.length>1">
                            <table class="responsive-table relative">
                                <thead>
                                  <tr>
                                      <th v-for="(item3, index) in item2.sumSameCurrency" :key="'tabs-'+index" style="font-size: 10px;padding: 1px;border-collapse: collapse;border: 1px solid black;background-color: #4299e1;">{{item3.currency}}</th>
                                  </tr>   
                                </thead>
                                <tbody>  
                                  <tr>
                                      <td  v-for="(item4, index) in item2.sumSameCurrency" :key="'tabh-'+index" style="padding: 1px;border-collapse: collapse;border: 1px solid black;">{{item4.sum.toFixed()}}</td>
                                  </tr>    
                                </tbody>
                            </table> 
                          </span>
                          <span v-else>{{item2.sum.toFixed()}}</span>
                      </td>
                      <td  v-if="item2.name=='Total pending'" style="border: 1px solid black;border-collapse: collapse;vertical-align: middle;display: table-cell;" :style="randomHexColor(item2.index)" :class="item2.mad?'':'background: repeating-linear-gradient(45deg,#FFFFFF,#FFFFFF 10px,#DDDDDD 10px,#DDDDDD 20px) !important'">{{item2.mad?item2.mad.toFixed():''}}</td>
                    </template>
                  <td style="border: 1px solid black;border-collapse: collapse;vertical-align: middle;display: table-cell;">{{ele[2].method}}</td>
                  <td style="border: 1px solid black;border-collapse: collapse;vertical-align: middle;display: table-cell;">  {{ele[2].userDataRib?numberWithSpaces(ele[2].userDataRib.toString()):'' }}</td>
                </tr>
                <!-- <tr class="intro-x" style="background-color: #4299e1;color: #fff;" v-if="dataItems.length>0">
                  <td scope="row" class="text-left-imp font-bold text-gray-700 fz-14" style="color: white;border: 1px solid black;border-collapse: collapse;vertical-align: middle;display: table-cell;">Total :</td>
                  <template v-for="(item) in dataItems" >
                      <td style="border: 1px solid black;border-collapse: collapse;vertical-align: middle;display: table-cell;">{{item.count}}</td>
                      <td style="border: 1px solid black;border-collapse: collapse;vertical-align: middle;display: table-cell;">
                          <span v-if="item.sumSameCurrency && item.sumSameCurrency.length>1">
                            <table class="responsive-table relative">
                                <thead>
                                  <tr>
                                      <th v-for="(item3, index) in item.sumSameCurrency" :key="'tabs-'+index" style="font-size: 10px;padding: 1px;color: white;background:black;">{{item3.currency}}</th>
                                  </tr>   
                                </thead>
                                <tbody>  
                                  <tr>
                                      <td  v-for="(item4, index) in item.sumSameCurrency" :key="'tabh-'+index" style="padding: 1px;font-size: 13px;background: white;color: black">{{item4.sum.toFixed()}}</td>
                                  </tr>    
                                </tbody>
                            </table> 
                          </span>
                          <span v-else>{{item.sum.toFixed()}}</span>
                      </td>
                    </template>
                    <td ></td>
                </tr>               -->
         </tbody>
        <tbody v-else>
          <tr v-if="items.length == 0" >
            <th class="border p-3 bg-gray-100" colspan="3">
              No payments found
            </th>
          </tr>
          <tr class="text-center" v-for="(item, index) in items" :key="index" :class="index % 2 == 0 ? 'bg-gray-100' : ''">
            <td class="border p-2">
              <span class="flex items-center">
                {{ item._id.seller[0].fullName }}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.count }}
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{ item.amount.toFixed() }}
              </span>
            </td>
          </tr>
          </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    dataItems: Array,
    type:String,
    currentUser: { type: Object},
    idWharhouse: { type: Object}
  },
  mounted() {
    // const pdf = document.querySelector("#pdf").cloneNode(true);
    // document.querySelector("#app").before(pdf);
    // document.querySelector("#app").style.display = "none";
    // window.print();
    // pdf.remove();
    // document.querySelector("#app").style.display = "block";
    // this.exportToExcel()
    // this.$emit("printed");
    //console.log('items excel____',this.items)
  },
  methods: {
    // getRestDays(endDate) {
    //   return this.$options.filters.toDays(endDate, Date.now());
    // },
    numberWithSpaces(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(".");
    },
    randomHexColor(index) {
        const colors=["#ba96ce", "#679c9d", "#c6c42c", "#48b41b", "#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf", "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234", "#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158", "#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647", "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3", "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", ];
        return 'background: ' + colors[index];        
     },
    DataParse(data){
        if (typeof data !== 'undefined') {
          return JSON.parse(data);
        }
        return ''; 
    },
    sumQteProduct(data){
      let sum=0;
      for (let i in data) {
        sum=sum+data[i].quantity;
      }
      return sum;
    },
    sumProduct(data){
      let product="";
      for (let i in data) {
        product+=data[i].product.name
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },
  }
};
</script>
<style scoped>
table {
  page-break-inside: auto;
}
tr {
  page-break-inside: avoid;
  page-break-after: auto;
}
thead {
  display: table-header-group;
}
tfoot {
  display: table-footer-group;
}
</style>
